import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Book from "@/pages/Book";
import BookWedding from "@/pages/BookWedding";
import BookAnniversary from "@/pages/BookAnniversary";
import Stay from "@/pages/Stay";
import CharDham from "@/pages/CharDham";
import Weddings from "@/pages/Weddings";
import Triyuginarayan from "@/pages/Triyuginarayan";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import Blog from "@/pages/Blog";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Policy from "@/pages/Policy";
import Experiences from "@/pages/Experiences";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/book" element={<Book portalKey="stay" />} />
            <Route path="/book/yatra" element={<Book portalKey="yatra" />} />
            <Route path="/book/wedding" element={<BookWedding />} />
            <Route path="/book/anniversary" element={<BookAnniversary />} />
            <Route path="/book/event" element={<Book portalKey="event" />} />
            <Route path="/book/transport" element={<Book portalKey="transport" />} />
            <Route path="/stay" element={<Stay />} />
            <Route path="/stays" element={<Stay />} />
            <Route path="/chardham" element={<CharDham />} />
            <Route path="/yatra" element={<CharDham />} />
            <Route path="/weddings" element={<Weddings />} />
            <Route path="/weddings/triyuginarayan" element={<Triyuginarayan />} />
            <Route path="/events" element={<Book portalKey="event" />} />
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy" element={<Policy kind="privacy" />} />
            <Route path="/terms" element={<Policy kind="terms" />} />
            <Route path="/cancellation" element={<Policy kind="cancellation" />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
